export default "__VITE_ASSET__CMSi3xN7__"